/* src/app/features/honra/janela/janela-solicitacao-honra-pesquisa/janela-solicitacao-honra-pesquisa.component.scss */
.mensagem-erro {
  font-size: 0.875em;
}
/*# sourceMappingURL=janela-solicitacao-honra-pesquisa.component.css.map */
